import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import {StoreService} from 'src/app/services/store.service'
import { ToastService } from 'src/app/services/toast.service';
import {  LoadingController, NavController } from '@ionic/angular';
import { IonInfiniteScroll } from '@ionic/angular';

@Component({
  selector: 'app-sub-category-list',
  templateUrl: './sub-category-list.page.html',
  styleUrls: ['./sub-category-list.page.scss'],
})
export class SubCategoryListPage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  category: any;
   subCategory: any;
   storeDetail: any;
   city = localStorage.getItem('city');
   pin: any;
   page_number: number = 1;
   isLoading: boolean = false;
   productFound: boolean = false;
   limit = 600;
   noDataImage: boolean = false;
   locationFlag: any = 0;
   count: any;
   productList: any=[];
   skipRole : any;
   a : any;
   offset : any=0;
  storeId : any;
  check: any=0;
  constructor(private service: StoreService,private toast: ToastService,
    private router: Router,
    private routerActivate:ActivatedRoute,
    private navController:NavController, public loadingController: LoadingController) { }

  ngOnInit() {
    // this.storeId=this.routerActivate.snapshot.params.storeId;
    this.category=this.routerActivate.snapshot.params.category;
    if(this.category==1){
      this.category="";
    }
    this.city=localStorage.getItem("city")
    this.page_number=0;
    this.ionViewWillEnter();
    
  }
  
   ViewMoreProd(category: any, subCat: any) {
    // let navigationParams: NavigationExtras = { state: { cat: category, subCat: subCat,storeDetail:this.storeDetail, isPromoActiveFlag: 'G' } };
    this.router.navigate(['/grocery-list/'+category+'/'+subCat])
   
  }

   
  Wishlist(){
    this.router.navigate(['../home/wishlist'])
  }

  ionViewWillEnter(){
    this.listOfProduct()
    }
    listOfProduct() {
      var cart = JSON.parse(localStorage.getItem("cart"))
      this.productList=[]
      this.isLoading = true;
      const promoListobj = {
        cat: this.category,
        subcat: this.subCategory,
        limit: this.limit,
        // storeid: this.storeId,
        city:this.city,
        offset : this.offset
      }
      this.service.getProduct(promoListobj).subscribe((data: any) => {
        this.isLoading = false;
        if (data.code == 2 && this.page_number == 1) {
          this.noDataImage = true
        } else if (data.code == 3 && this.page_number == 1) {
          this.noDataImage = true
  
        } else {
  
          for (let i = 0; i < data.length; i++) {
  
            this.productFound = true;
            this.count = 0;
            for (let j = 0; j < this.productList.length; j++) {
              if (this.productList[j].articleNumber == (data[i].articleNumber)) {
                this.count++;
              }
            }
            if (this.count == 0) {
              this.productList.push(data[i]);
              var product = cart.filter((element: any)=>element.id==this.productList[i]._id)[0]
              if(product)
              this.productList[i]['qty'] = product.qty
            
  
            }
  
  
  
  
          }
      
  
          console.log("product detail API hit", this.productList)
          console.log("dataImage", this.noDataImage)
        }
        if (this.productList.length > 0) {
          this.check = 0;
        } else {
          this.check = 1;
          console.log("hekkkk")
        }
  
      }, (error: any) => {
  
      });
      this.presentLoading()
    }

  
 
goBack(){
  this.navController.pop();
}
  

  notifications(){
    this.router.navigate(['/wishlist'])
  }

  productCheck(item){
    if(item.name&&item.price)
    return "productVisible"
    else 
    return "productHide"

  }
  home(){
    this.router.navigate(['/'])
  }
  async presentLoading() {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
      duration: 3000,
    });
    await loading.present();

    const { role, data } = await loading.onDidDismiss();
    console.log('Loading dismissed!');
  }
}
